import { Stack } from '@hub/stack'
import { IconButton } from '@hub/button'
import { HubStyleObject } from '@hub/design-system-base'
import { GridViewMediumIcon, ListViewMediumIcon } from '@hub/icon'
import React, { useState } from 'react'
import { useRouter } from '../../next/router'

export type ViewType = 'auto' | 'list' | 'grid'

export const isViewType = (value: unknown): value is ViewType => {
  return typeof value === 'string' && ['auto', 'list', 'grid'].includes(value)
}

export const useViewControlWithRouter = (defaultValue: ViewType): any => {
  const router = useRouter()
  const [state, setState] = useState<ViewType>(() => {
    const storedViewValue = router.query.viewMode || defaultValue || 'auto'
    return storedViewValue as ViewType
  })

  const setViewMode = (value: ViewType): void => {
    setState(value)

    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, viewMode: value },
      },
      undefined,
      { shallow: true }
    )
  }

  return [state, setViewMode]
}
export interface ViewControlProps {
  value: ViewType
  onChange: (value: ViewType) => void
  sx?: HubStyleObject
}

export const ViewControl: React.FC<ViewControlProps> = ({
  value,
  onChange,
  sx,
}) => (
  <Stack direction="row" sx={sx}>
    <IconButton
      variant="plainIcon"
      size="md"
      sx={{
        color:
          value === 'auto'
            ? ['manatee', null, 'licorice']
            : value === 'grid'
            ? 'licorice'
            : 'manatee',
      }}
      icon={<GridViewMediumIcon boxSize="size-icon-md" />}
      onClick={() => onChange('grid')}
      aria-label="Set to grid view"
    />
    <IconButton
      variant="plainIcon"
      size="md"
      sx={{
        color:
          value === 'auto'
            ? ['licorice', null, 'manatee']
            : value === 'list'
            ? 'licorice'
            : 'manatee',
      }}
      icon={<ListViewMediumIcon boxSize="size-icon-md" />}
      onClick={() => onChange('list')}
      aria-label="Set to list view"
    />
  </Stack>
)
